import '@backstage/cli/asset-types'
import '@backstage/ui/css/styles.css'
// @ts-ignore Could not find a declaration file for module 'react-dom/client'
import { createRoot } from 'react-dom/client'
import app from './App'
import * as Plausible from './plausible'

Plausible.startTracking()

const rootElement = document.getElementById('root') as HTMLElement
const root = createRoot(rootElement)
root.render(app)
